import { useQuery } from "react-query";
import { GET_AREAS_OF_CONCERN, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getAreasOfConcern } from "api/customers";
import extractRecords from "../utils/extractRecords";

export interface AreaOfConcernEntry {
  id: number;
  areaOfConcern: string;
  concernEntry: string | null;
  reportedDate: string | null;
  reportedBy: number | null;
  reportedByName: string | null;
}

const useGetAreasOfConcern = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_AREAS_OF_CONCERN, clientId],
    () => getAreasOfConcern(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    areasOfConcern: extractRecords<AreaOfConcernEntry>(data),
    areasOfConcernLoading: isLoading,
    refetchAreasOfConcern: refetch,
    ...rest,
  };
};

export default useGetAreasOfConcern;
